import GlideAutoCarousel from "design-system/resources/assets/js/glideAutoSlide";
import TextCarouselGlide from "design-system/resources/assets/js/textCarouselGlide";

export default function getIdCarouselForGlideSlide() {
  const glideSelectors = document.querySelectorAll('.glide');

  glideSelectors && glideSelectors.forEach((e)=>{
    e.style.visibility = "visible";
    var currId = e.getAttribute('id');
    if(currId === "header_text-carousel") {
      TextCarouselGlide();
    } else {
      GlideAutoCarousel("#" + currId);
    }
  })
}